import { gql } from '@apollo/client';

export const GET_CRM_LEAD_SOURCES = gql`
    query GetCrmLeadSources {
        getCrmLeadSources {
            _id
            sources {
                key
                label
            }
        }
    }
`;
